import { Collection } from "../Collection";
import { SimpleSignal } from "../SimpleSignal";
import { IInput, IInputConfig } from "./Input";

export interface ISelectInputConfig<T> extends IInputConfig
{
	id            ? : string;
	values        ? : Collection<T>
	labelProperty ? : string;
	value         ? : string;
	selectedIndex ? : number;
	disabled      ? : boolean;
	element       ? : HTMLSelectElement
}

export class SelectInput<T> implements IInput
{

	public config:ISelectInputConfig<T>;
	public id:string;
	public element:HTMLSelectElement;
	public changeSignal: SimpleSignal;
	public _value:T;
	public _values: Collection<T>;

	constructor(config:ISelectInputConfig<T>)
	{
		this.config = config || {};

		this.id = config.id;
		this.changeSignal = new SimpleSignal();

		this.initGUI();

		var values = config.values;
		if (values)
		{
			this.setValues(values);
		}

		if (config.value !== undefined)
		{
			this.setValueByKey(config.value);
		}

		if (config.selectedIndex >= 0)
		{
			this.value = this._values.array[config.selectedIndex];
		}

		if (config.disabled)
		{
			this.setEnabled(false);
		}
	}

	public show()
	{
		this.element.classList.remove("hidden");
	}

	public hide()
	{
		this.element.classList.add("hidden");
	}

	private initGUI()
	{
		var el = this.config.element || document.createElement("select");

		el.addEventListener("change", this.onChange);
		this.element = el;
	}

	private onChange = (event:Event) =>
	{
		var selectedOption = this.element.options[this.element.selectedIndex];

		var selectedValue = this._values.getByKey(selectedOption.value);

		this._value = selectedValue;

		this.dispatchChange(event);
	};

	public dispatchChange(event:Event)
	{
		var value = this._value[this._values.keyProperty];
		if (value === undefined)
		{
			value = this._value;
		}

		this.changeSignal.dispatch(value, this, event);
	}

	public setValueByKey(key:string)
	{
		var value = this._values.getByKey(key);
		this.value = value;
	}

	public setValues(values: Collection<T>)
	{
		this._values = values;

		this.refreshOptions();

		this._values.change.add(this.onValuesChange);
	}

	private refreshOptions()
	{
		// remove all children
		this.element.innerHTML = "";

		var idProperty    = this._values.keyProperty;
		var labelProperty = this.config.labelProperty || "label";

		var valuesArray = this._values.array;
		for (var i = 0, ln = valuesArray.length; i < ln; ++i)
		{
			var value  = <any>valuesArray[i];
			var option = document.createElement("option");

			option.value       = value[idProperty];
			option.textContent = value[labelProperty];

			//if (this.config.value === value.value)
			//{
			//	option.selected = true;
			//}

			this.element.appendChild(option);
		}
	}

	private onValuesChange = () =>
	{
		this.refreshOptions();
	};

	public enable()
	{
		this.element.disabled = false;
	}

	public disable()
	{
		this.element.disabled = true;
	}

	public set value(value:T) {

		this._value = value;

		var valuesArray = this._values.array;
		for (var i = 0; i < valuesArray.length; ++i)
		{
			if (valuesArray[i] === value)
			{
				this.element.selectedIndex = i;
				return;
			}
		}
	}

	public get value()
	{
		return this._value;
	}

	public setEnabled(value:boolean)
	{
		this.element.disabled = !value;
	}
}